import type { Paper as PaperData } from '@mathflat/domain/Paper'
import type { SchoolType } from '@mathflat/domain/SchoolSystem'
import { computed, makeObservable, observable } from 'mobx'

import { EMPTY_NUMBER_ID } from '@/constant/common'
import commonRepo from '@/repository/common.repo'
import { curriculumCoreService } from '@/service/curriculumCore.service'
import dateUtils from '@/utils/DateUtils'

import { DTO } from '../DTO'
import { SchoolGrade } from '../Student'

export class Paper extends DTO {
  id: PaperData['id'] = EMPTY_NUMBER_ID
  type: PaperData['type'] = 'SCHOOL_TEST_PAPER'
  title: PaperData['title'] = ''
  schoolName: PaperData['schoolName'] = null
  schoolCode: PaperData['schoolCode'] = null
  schoolTestYear: PaperData['schoolTestYear'] = null
  schoolTestType: PaperData['schoolTestType'] = null
  gradeSemester: PaperData['gradeSemester'] = ''
  trieKey: PaperData['trieKey'] = ''
  pdfUrl: PaperData['pdfUrl'] = ''
  pages: PaperData['pages'] = []
  boxes: PaperData['boxes'] = []
  createDatetime: Date = new Date()

  constructor(data: PaperData) {
    super()

    if (data) {
      Object.assign(this, data)
    }

    this.createDatetime = new Date(data.createDatetime)

    makeObservable(this, {
      id: observable,
      type: observable,
      title: observable,
      schoolName: observable,
      schoolCode: observable,
      schoolTestYear: observable,
      schoolTestType: observable,
      gradeSemester: observable,
      trieKey: observable,
      pdfUrl: observable,
      pages: observable,
      boxes: observable,
      createDatetime: observable,
      korGradeSemester: computed,
      isNew: computed,
      isUsable: computed,
    })
  }
  get korGradeSemester() {
    const info = curriculumCoreService.getItemByTrieKey(this.trieKey)
    if (!info) return '중 1-1'
    return SchoolGrade.getKoreanWorkbookGradeSemesterRevision({
      type: 'ALL',
      schoolType: info.schoolType as SchoolType,
      grade: info.gradeSubject,
      semester: info.semester,
      revision: info.revision,
    })
  }
  get isNew() {
    return dateUtils.isIn24Hours(this.createDatetime)
  }
  get isUsable() {
    if (commonRepo.isSolo) {
      return commonRepo.permission.bySubscription.validateSubscription({
        trieKey: this.trieKey,
      })
    }
    return true
  }

  setPages(pages: PaperData['pages']) {
    this.pages = pages
  }
}
